import { useCallback } from 'react';

/**
 * Sometimes you need to combine a few callbacks before passing them to a component. That's what this
 * function does.
 *
 * - Each function is expected to have the same function signature.
 * - IMPORTANT: All functions passed should be memoized.
 */
export function useBatchedCallback<T extends (...args: Parameters<T>) => void>(
  ...funcs: (T | undefined)[]
): T {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    ((...args) => {
      funcs.forEach(func => func && func(...args));
    }) as T,
    funcs
  );
}
